import logo from "../../assets/images/myanwan/logo.png";
import { CiLocationOn } from "react-icons/ci";
import { MdOutlinePhone } from "react-icons/md";
import { MdOutlineMail } from "react-icons/md";
import { SlSocialFacebook } from "react-icons/sl";
import { FaInstagram } from "react-icons/fa6";
import { RiTelegramLine } from "react-icons/ri";
const Footer = () => {
  return (
    <footer id="footer" className="py-10 md:py-14  text-sm">
      <div className="max-w-6xl mx-auto px-5 grid md:grid-cols-6 gap-10 lg:grid-cols-11 lg:gap-5">
        <div className="col-span-3 space-y-5 flex items-center justify-center">
          <div className="max-w-[100px] aspect-square">
            <img
              src={logo}
              alt="urban footer logo "
              className="w-full h-full object-cover"
            />
          </div>
        </div>
        <div className="space-y-5 col-span-3">
          <p>
            Myanmar Women Entrepreneurs Network (MYANWEN) is a non-profit
            non-governmental organization founded in April 2020 with the vision
            to support the socio-economic development of Myanmar by providing
            guidance to women-led businesses and high-achieving Myanmar women
            entrepreneurs.
          </p>
        </div>
        <div className="space-y-5 col-span-3 ">
          <h6 className="text-2xl font-bold uppercase">INFORMATIONS</h6>
          <ul className="space-y-3">
            <li className="flex  gap-2">
              <p>
                <CiLocationOn size={25} />
              </p>
              <p>
                No. 46, Building B, Pyay Road, 6.5 Mile, Hlaing Township,
                Yangon.
              </p>
            </li>
            <li className="flex gap-2">
              <p>
                <MdOutlinePhone size={25} />
              </p>
              <p>09 4200 77136,09 7500 54341</p>
            </li>
            <li className="flex gap-2 ">
              <p>
                <MdOutlineMail size={25} />
              </p>
              <p>myanwen@gmail.com </p>
            </li>
          </ul>
        </div>
        {/* <div className="space-y-5 col-span-3">
          <h6 className="text-2xl font-bold uppercase">Useful Information</h6>
          <ul className="space-y-3">
            <li>
              <a href="#">About Us </a>
            </li>
            <li>
              <a href="#">Services </a>
            </li>
            <li>
              <a href="#">Shop </a>
            </li>
            <li>
              <a href="#">Projects </a>
            </li>
            <li>
              <a href="#">Contact Us</a>
            </li>
          </ul>
        </div> */}
        <div className=" space-y-5 col-span-3 lg:col-span-2">
          <h6 className="text-2xl font-bold uppercase">Follow Us</h6>
          <ul className="flex items- gap-5">
            <li>
              <a href="#">
                <SlSocialFacebook size={30} />
              </a>
            </li>
            <li>
              <a href="#">
                <FaInstagram size={30} />
              </a>
            </li>
            <li>
              <a href="#">
                <RiTelegramLine size={30} />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
